import React, { useRef } from "react";
import { RouterProvider } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "react-query";
import { ReactQueryDevtools } from "react-query/devtools";
import { router } from "./utils/router";
import { withOneTabEnforcer } from "react-one-tab-enforcer";
import {
  clearAccessToken,
  clearLocal,
  clearRefreshToken,
  getLocal,
  setAccessToken,
  setLocal,
  setRefreshToken,
} from "./hooks/auth";
import { useSelector } from "react-redux";
import axiosInstance from "./services/api";
import { Box, Center, HStack, Icon, Image, Text } from '@chakra-ui/react';
import altpowerLogo from './assets/Home/general/altpower_logo.png';

function CustomWarningComponent() {
  return <div>
    <Center px={['auto']} bg={'brand.40'} width={'100%'}>
      <Box mt={24} width={['90%', '25%']}>
        <Image
          mt={8}
          src={altpowerLogo}
          w={'80px'}
          h={'auto'}
          alt={'altpower logo'}
        />
        <Text mt={12} mb={12} fontSize={'22px'}>No Multiple Tabs Allowed</Text>
        
      </Box>
    </Center>
  </div>;
}

function App() {
  const queryClient = new QueryClient();

  const authStatus = getLocal("auth");
  const userInfo = useSelector((state) => state.user?.userData);
  const userData = getLocal('user') || userInfo;
  let accessedToken = getLocal('cess');
  let refreshedToken = getLocal('resh');
  const storedId = getLocal('ID');
  const isRefreshing = useRef(false);


  const updateTokensInLocalStorage = (accessToken, refreshToken) => {
    accessedToken = accessToken;
    refreshedToken = refreshToken;

    setLocal('cess', accessToken);
    setLocal('resh', refreshToken);
  };


  const startTimer = () => {
    let remainingTime = 3.0 * 60;
    const timerId = setInterval(() => {
      remainingTime--;
     ;

      if (remainingTime === 0) {
        clearInterval(timerId);
        refreshTokenCall();
      }
    }, 1000);
  };


  const refreshTokenCall = async () => {
    if (authStatus === true && !isRefreshing.current) {
      isRefreshing.current = true;
      try {
        const response = await axiosInstance.post("/Customers/refreshtoken", {
          userId: storedId,
          refreshToken: refreshedToken,
        });

        if (response?.data?.responseCode === "00") {

          const { accessToken, refreshToken } = response?.data?.data;

          // Update userData with the new tokens
          updateTokensInLocalStorage(accessToken, refreshToken);

          // Update the tokens in memory if they’re managed separately
          setAccessToken(accessToken);
          setRefreshToken(refreshToken);

          startTimer();
        } else {
          setLocal("auth", false);
          clearLocal('user');
          clearAccessToken();
          clearRefreshToken();
          isRefreshing.current = false;
          // Handle error
        }
      } catch (error) {
        throw error;
      }
    } else {
      isRefreshing.current = false;
      return;
    }
  };

  React.useEffect(() => {
    try {
      // Check if the environment supports Web Workers
      if (typeof Worker !== 'undefined') {
        console.warn('Web Workers are not supported in this environment.');
      }
      else {
        console.warn('Web Workers are not supported in this environment.');
      }
    } catch (error) {
      // Handle the error, for example by displaying a fallback UI or logging the error
    }
  }, []);

  React.useEffect(() => {
    if (authStatus === true && !isRefreshing.current) {
      startTimer();
    }


  }, [authStatus]);

  return (
    <>
      <QueryClientProvider client={queryClient}>
        <RouterProvider router={router}></RouterProvider>
        {/* <ReactQueryDevtools position="bottom-right" /> */}
      </QueryClientProvider>
    </>
  );
}

export default withOneTabEnforcer({
  appName: "Altpower-Customer",
  OnlyOneTabComponent: CustomWarningComponent,
})(App);
